
const DragPreview = ({ subject, position, offset, dimensions, children, customStyle }) => {
    if (!position || (!subject && !children)) return null;

    const defaultStyle = {
        position: 'fixed',
        zIndex: 9999,
        opacity: 0.9,
        backgroundColor: (subject && subject.color) || '#ddd',
        // Default padding removed to allow customStyle or children to dictate
        borderRadius: '4px',
        border: '1px solid #333', // Keep border but might need to match source
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        display: 'flex', // Default to flex as both sources use it
        alignItems: 'center', // Common alignment
        boxSizing: 'border-box'
    };

    const style = { ...defaultStyle, ...customStyle };

    if (offset) {
        style.left = position.x - offset.x;
        style.top = position.y - offset.y;
    } else {
        style.left = position.x;
        style.top = position.y;
        style.transform = 'translate(-50%, -50%)';
    }

    if (dimensions) {
        style.width = dimensions.width;
        style.height = dimensions.height;
    }

    return (
        <div style={style}>
            {children || (subject ? subject.subjectname : '')}
        </div>
    );
};

export default DragPreview;
